import ApiClient from "./apiClient";

const settingsService = {
  getAdvancedSettings: () => ApiClient.get("settings/advanced-settings"),
  saveAdvancedSettings: (payload: Record<string, any>) =>
    ApiClient.post("settings/advanced-settings", payload),
};

export default settingsService;
